var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-textarea-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "custom-textarea-placeholder",
        class: _vm.placeholder_class,
      },
      [_vm._v(_vm._s(_vm.custom_placeholder))]
    ),
    _vm._m(0),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isFormatter && _vm.formatterShow,
            expression: "isFormatter && formatterShow",
          },
        ],
        ref: `formatter_${_vm._ref}`,
        staticClass: "textFormatter",
        class: _vm.formatterShow ? "" : "hidden",
        attrs: { id: "textFormatter" },
      },
      [
        _c("div", { staticClass: "tfbuttons" }, [
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: { type: "button", title: _vm.$t("chat.bold-text") },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.BOLD)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-bold" })]
          ),
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: { type: "button", title: _vm.$t("chat.italic-text") },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.ITALIC)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-italic" })]
          ),
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: { type: "button", title: _vm.$t("chat.underline-text") },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.UNDERLINE)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-underline" })]
          ),
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: {
                type: "button",
                title: _vm.$t("chat.strikethrough-text"),
              },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.STRIKE)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-strikethrough" })]
          ),
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: { type: "button", title: _vm.$t("chat.hashtag") },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.HASHTAG)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-hashtag" })]
          ),
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: { type: "button", title: _vm.$t("chat.monospace-text") },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.MONOSPACE)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-text-width" })]
          ),
          _c(
            "button",
            {
              staticClass: "tfbutton",
              attrs: { type: "button", title: _vm.$t("chat.codeblock-text") },
              on: {
                click: function ($event) {
                  return _vm.formatSelection(_vm.ENTITIES.CODEBLOCK)
                },
              },
            },
            [_c("i", { staticClass: "fal fa-code" })]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        ref: _vm._ref,
        staticClass: "custom-textarea",
        attrs: { id: "custom-textarea1", contenteditable: !_vm.disabled },
        on: {
          focus: function ($event) {
            return _vm.focus(true)
          },
          paste: _vm.paste,
          blur: function ($event) {
            return _vm.focus(false)
          },
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.send($event)
            },
            _vm.onKeyDown,
          ],
          input: _vm.update,
          keyup: _vm.onKeyup,
          contextmenu: _vm.onClick,
          click: _vm.onClick,
          dblclick: _vm.onClick,
        },
      },
      [_vm._v(_vm._s(_vm.text))]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }